/**
 * [TODO]
 * BtnShareTrigger 인스턴스를 각 ShareNavigator, 와 ShareLayer 에서 생성 하는 것으로 바꿔 보자.
 * constructor 옵션으로 ShareNavigator, 와 ShareLayer 인스턴스를 넘겨 주고, 옵션으로 포지션 할지 안할지 하는것으로,
 *
 * 마찬가지로 Breakpoint 를 위한 resize 이벤트도 ShareNavigator, 와 ShareLayer 에서 생성 하는 것으로 바꿔 보자.
 *
 * index.ts 에서 하는 건 옵션 정리 정도만 해보자
 *
 *
 */
import { getLangByHtml } from '@ncui/util-js/Utils';

// import { getLangForL10n } from "../common/Utils";
import { AbsShare } from "./share/AbsShare";
import { BtnShareTrigger } from "./share/feature/BtnShareTrigger";
import { BtnShareTriggerWithShareLayer } from "./share/feature/BtnShareTriggerWithShareLayer";
import { ShareLayer } from "./share/ShareLayer";
import { ShareNavigator } from "./share/ShareNavigator";
import { checkDevice } from "./Utils";
import l10n from './L10n';

export const COMMON = 'COMMON';

const DEFAULT_OPTION: ShareOption = {
    snsOrder: ['facebook', 'line', 'copy', 'twitter'],
    shareUrl: window.location.href || '/',
    langCode: getLangByHtml(),
    useNavigatorShare: true,
    dimmed: true,
    title: "",
    beforeShareAsync: async () => true,
    afterShareAsync: async () => true,
    customClass: "",
    useCloseBtn: true, 
    // wrappperElSelector: '#test',
    // btnShareTrigger: {
    //     selector: '.btn-share',
    //     staticDistanceFromBtnToLayer: [0, 0]
    // }
    // breakpoint: {
    //     '360':{
    //         snsOrder: ['facebook', 'line', 'copy', 'twitter'],
    //         shareUrl: window.location.href || '/',
    //         langCode: "ko",
    //         useNavigatorShare: true,
    //         dimmed: true,
    //         title: "",
    //     }
    // },
}
export default class Index {
    #shareInstance: AbsShare;

    constructor(private inputedOption: InputedShareOption) {
        this.#shareInstance = this.setShareInstance();
    }

    setShareInstance() {
        console.log(this.#optionMap)
      
        if (this.#isNavigatorShare) {
            return new ShareNavigator(this.#optionMap);
        } else {
            return new ShareLayer(this.#optionMap);
        }
    }

    public open() {
        this.#shareInstance.open();
    }

    public close() {
        this.#shareInstance.close();
    }

    // 초기 옵션 정리
    get #optionMap(): ShareOptionMap{
        // DEFAULT_OPTION 과 inputedOption을 머지 하여, 머지된 mergedCommonOption 과, 아직 머지 되지 않은 inputedBreakpointOptions 을 뽑아낸다.
        const {breakpoint: inputedBreakpointOptions = {}, ...mergedCommonOption} = { ...DEFAULT_OPTION, ...this.inputedOption};

        // inputedBreakpointOptions 과 mergedCommonOption 을 머지 하여 mergedCommonOption 을 뽑아 낸다.
        const _eachBreakpointOption = {...Object.fromEntries(Object.entries(inputedBreakpointOptions).map(([breakpoint, breakpointOption])=>{
            return [breakpoint, {...mergedCommonOption, ...breakpointOption}];
        }))}

        // mergedCommonOption 을 정리
        const _commonOption = {COMMON: mergedCommonOption}

        // 둘이 합친다.
        const shareOptions = {..._commonOption, ..._eachBreakpointOption};

        // 언어파일이 없는 언어의 경우 en 으로 만들어 버린다.
        const _shareOptions: ShareOptionMap =  Object.fromEntries(Object.entries(shareOptions).map(([breakpoint, option]) => {
            let langArray = Object.keys(l10n) as (keyof typeof l10n)[];;

            if(!langArray.includes(option.langCode)){
               return [breakpoint, {...option, ...{langCode: 'en'}}]
            }else{
                return [breakpoint, option]
            }
        }));

        return _shareOptions;
    }

    public updateOption(option: Partial<InputedShareOption>){
      this.inputedOption = {...this.inputedOption, ...option};
      this.#shareInstance.updateOption(this.#optionMap)
    }

    public reRendering(){
      this.#shareInstance.reRendering()
    }

    // Navigator 사용 가능 한지 확인
    get #isNavigatorShare(){
        // 옵션에서 navigatorShare 사용하며, 디바이스가 모바일이고, navigatorShare 객체가 있을때
        return this.#usingNavigatorShareOption && this.#hasNavigatorShare;
    }

    // 옵션에서 navigatorShare 사용하며
    get #usingNavigatorShareOption() {
        return this.#optionMap[COMMON].useNavigatorShare;
    }

    // navigatorShare 객체가 있을때
    get #hasNavigatorShare() {
        console.log('usingNavigator', checkDevice() === 'MOBILE' && !!window.navigator.share)

        return checkDevice() === 'MOBILE' && !!window.navigator.share;
    }
}

